import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useWizard } from '../../context/WizardContext';
import OrganizationFields from '../../components/common/OrganizationForm/OrganizationFields';
import { PrimaryButton } from '../../components/common/ButtonsV2';

/**
 * StepOrganizationDetail is a step in a multi-step form (wizard)
 * that collects organization-related information such as name,
 * industry, and address fields. It validates the form inputs
 * and enables the "Next" button when all required fields are filled and valid.
 */
const StepOrganizationDetail = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { next, setStepValid, completeStep, canProceed, currentId } = useWizard();

  const [name, industry, street, city, stateVal, zip] = useWatch({
    control,
    name: ['name', 'industry', 'street', 'city', 'state', 'zip_code'],
  });

  useEffect(() => {
    const allFilled = [name, industry, street, city, stateVal, zip].every(
      (val) => typeof val === 'string' && val.trim() !== '',
    );
    const hasErrors = Object.keys(errors).length > 0;
    const isValid = allFilled && !hasErrors;

    if (canProceed !== isValid) {
      setStepValid(isValid);
    }
  }, [name, industry, street, city, stateVal, zip, errors, canProceed, setStepValid]);

  const onClickNext = () => {
    completeStep(currentId);
    next();
  };

  return (
    <div className="space-y-6 bg-white p-[50px] rounded-[10px] max-w-[626px] mt-[20px]">
      <h2 className="text-xl font-bold">Organization Detail</h2>

      {/* Form fields specific to the organization */}
      <OrganizationFields />

      {/* Navigation buttons - only "Next" in this step */}
      <div className="flex justify-end grid grid-cols-2 gap-4 !mt-[40px]">
        <div />
        <PrimaryButton type="button" fullWidth onClick={onClickNext} disabled={!canProceed}>
          Next
        </PrimaryButton>
      </div>
    </div>
  );
};

export default StepOrganizationDetail;
